import React from "react";
import { motion } from "framer-motion";
import TrainingHero from "../../../assets/pensiveMaleCustomer.png";

const ImageSection = () => {
  return (
    <div className="w-full flex items-center justify-center relative min-h-[300px]">
      {/* Person Image - Same as FAQ page */}
      <motion.div
        className="relative w-full max-w-[280px] h-[380px]"
        animate={{
          y: [0, -8, 0],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        {/* Main Container with Gradient Background */}
        <motion.div
          className="relative w-full h-full bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 rounded-3xl p-4 shadow-2xl border border-white/50 overflow-hidden"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          whileHover={{ scale: 1.02, rotateY: 5 }}
        >
          {/* Decorative Background Elements */}
          <div className="absolute inset-0 overflow-hidden rounded-3xl">
            <div className="absolute top-4 right-4 w-16 h-16 bg-gradient-to-br from-blue-200/30 to-purple-200/30 rounded-full blur-xl"></div>
            <div className="absolute bottom-6 left-6 w-12 h-12 bg-gradient-to-br from-orange-200/30 to-pink-200/30 rounded-full blur-lg"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-gradient-to-br from-green-200/20 to-blue-200/20 rounded-full blur-2xl"></div>
          </div>

          {/* Person Image */}
          <div className="relative z-10 flex flex-col items-center justify-center h-full">
            <motion.div
              className="relative mb-3 mt-3"
              animate={{
                scale: [1, 1.05, 1],
                filter: ["brightness(1)", "brightness(1.1)", "brightness(1)"],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              {/* TrainingHero Person Image - Full display */}
              <img
                src={TrainingHero}
                alt="Training Hero"
                className="w-52 h-52 object-contain"
              />
            </motion.div>

            {/* Text Labels */}
            <motion.div
              className="text-center"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            >
              <h3 className="text-lg font-bold text-gray-800 mb-2">
                Got Questions?
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Find answers to common questions about our training programs
              </p>
            </motion.div>

            {/* Sparkle Effects */}
            <motion.div
              className="absolute top-4 left-4 w-2 h-2 bg-yellow-400 rounded-full"
              animate={{
                scale: [1, 1.5, 1],
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />

            <motion.div
              className="absolute top-8 right-6 w-1.5 h-1.5 bg-blue-400 rounded-full"
              animate={{
                scale: [1, 1.3, 1],
                opacity: [0.7, 1, 0.7],
              }}
              transition={{
                duration: 2.5,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 0.5,
              }}
            />

            <motion.div
              className="absolute bottom-6 left-8 w-1 h-1 bg-purple-400 rounded-full"
              animate={{
                scale: [1, 1.2, 1],
                opacity: [0.6, 1, 0.6],
              }}
              transition={{
                duration: 1.8,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 1,
              }}
            />
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ImageSection;
